// ? UTIL file to copy content to clipboard

// ? Method to copy the text
const copyText = (textToBeCopied: any) => {
  navigator.clipboard.writeText(textToBeCopied);
};

export { copyText };
